export default "__VITE_ASSET__BIgkjqcH__"